import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=65f91c4a&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=ts"
export * from "./MessageDialog.vue?vue&type=script&lang=ts"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=65f91c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f91c4a",
  null
  
)

export default component.exports